import { useIntl } from 'react-intl';

import { FamilyPlanLandingProps } from '@/components/familyPlan/FamilyPlanLanding/types';
import GridWrapper from '@/components/ui/GridWrapper';

import { benefits } from './data';
import messages from './messages';
import {
	Benefit,
	BenefitDescription,
	BenefitHeading,
	BenefitIcon,
	BenefitsGrid,
	BenefitsWrapper,
	Heading,
	Wrapper,
} from './styles';

const Benefits = ({ isJoinFlow }: Omit<FamilyPlanLandingProps, 'onClick'>) => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper>
			<GridWrapper columns={3}>
				<Heading>{formatMessage(isJoinFlow ? messages.headingAccept : messages.heading)}</Heading>
				{benefits.length > 0 && (
					<BenefitsWrapper>
						<BenefitsGrid columns={3}>
							{benefits.map(benefit => {
								return (
									<Benefit key={formatMessage(benefit.heading)}>
										<BenefitIcon as={benefit.icon} />
										<BenefitHeading>
											{formatMessage(isJoinFlow ? benefit.headingAccept : benefit.heading)}
										</BenefitHeading>
										<BenefitDescription>
											{formatMessage(isJoinFlow ? benefit.descriptionAccept : benefit.description)}
										</BenefitDescription>
									</Benefit>
								);
							})}
						</BenefitsGrid>
					</BenefitsWrapper>
				)}
			</GridWrapper>
		</Wrapper>
	);
};

export default Benefits;
